import React, { Component } from 'react'
import { Row, Col } from 'react-bootstrap'
import '../../css/style.css';
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGithubSquare } from '@fortawesome/free-brands-svg-icons'
import { faLinkedin } from '@fortawesome/free-brands-svg-icons'


library.add(faGithubSquare, faLinkedin)

class Footer extends Component {


  render() {
    return (
      <Row className="footer">
        <Col xs="12" >
          <p className="footerCopy">Copyright &copy; kaipengyu.com 2026</p>
        </Col>
        <Col xs="12" >
          <p className="footerCopy"><strong>Contact me</strong>: <a className="footer-link" href="mailto:kaipengyudesign@gmail.com" target="_blank" rel="noopener noreferrer"> kaipengyudesign@gmail.com</a></p>
          <div className="social-media">

            <a className="social-media" href="https://www.linkedin.com/in/kaipengyu" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn profile">

              <FontAwesomeIcon icon={faLinkedin} size="2x" aria-hidden="true" />
            </a>
            <a className="social-media" href="https://github.com/kaipengyu" target="_blank" rel="noopener noreferrer" aria-label="GitHub profile">

              <FontAwesomeIcon icon={faGithubSquare} size="2x" aria-hidden="true" />
            </a>
          </div>
        </Col>
      </Row>
    )
  }
}

export default Footer